import { z } from '@/libs/zod';

export const ticketDetailsSchema = z.object({
  id: z.string(),
  sequence: z.string(),
  winning: z.boolean(),
  hasBeenScratched: z.boolean(),
  date: z.string(),
  prizes: z.array(
    z.object({
      name: z.string(),
      type: z.string(),
      isDrawn: z.boolean(),
      prizeUrls: z.string(),
      prizeValue: z.number(),
    }),
  ),
  raffle: z.object({
    id: z.string(),
    name: z.string(),
    drawDate: z.string(),
    urlThumbnail: z.string().optional(),
    urlScratcherBanner: z.string().optional(),
  }),
  user: z.object({
    cpf: z.string(),
    phone: z.string(),
    name: z.string(),
  }),
});

export type TicketDetails = z.infer<typeof ticketDetailsSchema>;

export type TicketDetailsParams = {
  ticketId: string;
  cpf: string;
  phone: string;
};
